import { useState } from 'react';
import { useStore } from '../store';
import { supabase } from '../lib/supabase';

export function useSurveyData() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const store = useStore();

  const saveSurveyData = async (fileData: any[], workshopColumn: string) => {
    try {
      setLoading(true);
      setError(null);

      if (!fileData || !workshopColumn) {
        throw new Error('No survey data to save');
      }

      // Get current session
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        throw new Error('يجب تسجيل الدخول أولاً');
      }

      const { axes, scaleMapping, analysisResults } = store;

      const { data, error: saveError } = await supabase
        .from('surveys')
        .insert({
          name: `Survey ${new Date().toLocaleDateString()}`,
          file_data: fileData,
          workshop_column: workshopColumn,
          axes: axes || {},
          scale_mapping: scaleMapping || {},
          analysis_results: analysisResults,
          user_id: session.user.id
        })
        .select()
        .single();

      if (saveError) throw saveError;
      return data;

    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to save survey data';
      setError(message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const loadSurveyData = async (id: string) => {
    try {
      setLoading(true);
      setError(null);

      // Get current session
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        throw new Error('يجب تسجيل الدخول أولاً');
      }

      const { data, error } = await supabase
        .from('surveys')
        .select()
        .eq('id', id)
        .eq('user_id', session.user.id)
        .single();

      if (error) throw error;
      if (!data) throw new Error('Survey not found');

      store.setFileData(data.file_data);
      store.setWorkshopColumn(data.workshop_column);
      if (data.axes) store.setAxes(data.axes);
      if (data.scale_mapping) store.setScaleMapping(data.scale_mapping);
      if (data.analysis_results) store.setAnalysisResults(data.analysis_results);

      return data;
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to load survey data';
      setError(message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    saveSurveyData,
    loadSurveyData
  };
}